import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});
export const fetchTryout = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      per_page,
    });

    // **Add this loop to append all properties from the filters object**
    for (const key in filters) {
      if (Object.hasOwnProperty.call(filters, key) && filters[key] !== undefined && filters[key] !== null) {
        params.append(key, filters[key]);
      }
    }

    const response = await axios.get(`${BASE_URL_BE}/tryout?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tryout:", error); // Changed from 'paket' to 'tryout' for consistency
    throw error;
  }
};

export const createTryout = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/tryout`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updateTryout = async (id_tryout, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/tryout/${id_tryout}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};

export const deleteTryout = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/tryout/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};


export const getTryoutById = async (id_tryout) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/tryout/${id_tryout}`, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};


export const getDetailTryout = async (jenis_seleksi, id_tryout) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/tryout/detail`, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      },
      params: {
        jenis_seleksi,
        id_tryout
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching detail tryout:", error);
    throw error;
  }
};

export const getSoalTryout = async ( id_paket, id_jenis_seleksi, id_tipe_konten) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/tryout/soal`, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      },
      params: {
        id_paket,
        id_jenis_seleksi,
        id_tipe_konten
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching detail tryout:", error);
    throw error;
  }
};


export const tryoutAddResults = async (idPaket, idJenisSeleksi, idTipeKonten) => {
  try {
    const formData = new FormData();
    // Append each key-value pair separately
    formData.append('id_paket', idPaket);
    formData.append('id_jenis_seleksi', idJenisSeleksi);
    formData.append('id_tipe_konten', idTipeKonten);

    const response = await axios.post(
      `${BASE_URL_BE}/tryout-results`,
      formData,
      {
        headers: {
          ...getAuthHeaders(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding tryout results:", error);
    throw error;
  }
};

export const tryoutAddResultsDetails = async (payload) => { // <-- Parameter harus 'payload'
  try {

    const response = await axios.post(
      `${BASE_URL_BE}/tryout-results/details`,
      payload, 
      {
        headers: {
          ...getAuthHeaders(),

        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding tryout results:", error);
    throw error;
  }
};




export const tryoutGetRiwayat = async (idPaket, idTipeKonten, idJenisSeleksi, page = 1, per_page = 10) => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}/tryout-results/riwayat`,
      {
        headers: {
          ...getAuthHeaders(),
        },
        params: { // Sertakan parameter baru di sini
          id_paket: idPaket,
          id_tipe_konten: idTipeKonten,   // <-- Tambahan
          id_jenis_seleksi: idJenisSeleksi, // <-- Tambahan
          page: page,
          per_page: per_page
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tryout history:", error);
    // Lebih baik melempar error agar dapat ditangani di komponen
    throw error;
  }
};

export const tryoutGetSummarySkor = async (idTryoutAnswer, idTipeKonten, idJenisSeleksi) => { 
  try {
    const response = await axios.get(
      `${BASE_URL_BE}/tryout-results/summary-skor`, 
      {
        headers: {
          ...getAuthHeaders(),
        },
        params: {
          id_tryout_answer: idTryoutAnswer, 
          id_tipe_konten : idTipeKonten,
          id_jenis_seleksi : idJenisSeleksi
        }
      } 
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tryout analysis score:", error); 
    throw error;
  }
};

export const tryoutGetAnalisaSkor = async (idTryoutAnswer, idjenisSeleksi, idTipeKonten, idPaket) => { 
  try {
    const response = await axios.get(
      `${BASE_URL_BE}/tryout-results/analisa-skor`, 
      {
        headers: {
          ...getAuthHeaders(),
        },
        params: {
          id_tryout_answer: idTryoutAnswer, 
          id_jenis_seleksi:idjenisSeleksi,
          id_tipe_konten:idTipeKonten,
          id_paket : idPaket
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tryout analysis score:", error); 
    throw error;
  }
};

export const tryoutGetPembahasan = async (idTryoutAnswer, jenisSeleksi) => { 
  try {
    console.log(idTryoutAnswer, "cek jenis seleksi")
    const response = await axios.get(
      `${BASE_URL_BE}/tryout-results/pembahasan`, 
      {
        headers: {
          ...getAuthHeaders(),
        },
        params: {
          id_tryout_answer: idTryoutAnswer, 
          id_jenis_seleksi:jenisSeleksi,
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tryout analysis score:", error); 
    throw error;
  }
};

export const getPembahasan = async (idTryout) => { 
  try {
    const response = await axios.get(
      `${BASE_URL_BE}/pembahasan`, 
      {
        headers: {
          ...getAuthHeaders(),
        },
        params: {
          id_tryout: idTryout, 
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pembahasan ", error); 
    throw error;
  }
};